import { Image, Text } from '@atoms/index';
import texts from '@components/ReferAndEarn/en.json';
import ReferralInfo from '@components/ReferAndEarn/ReferralInfo';
import { getAuth } from '@services/identity.service';
import { replaceKeysWithValues } from '@helpers/miscelleanous';
import {
    minRewardEligibilityAmount,
    referralRewardEligibilityDays,
} from '@components/ReferAndEarn/helper';
import { brandName } from '@helpers/constants';
import { useEffect, useState } from 'react';

const rewardSteps = [
    replaceKeysWithValues(texts?.SignUpToGetReferralLink, {
        '{brandName}': brandName,
    }),
    texts?.ShareWithFriends,
    replaceKeysWithValues(texts?.YouAndYourFriendGetReward, {
        '{minInvestmentAmount}': minRewardEligibilityAmount,
        '{eligibilityDays}': referralRewardEligibilityDays,
    }),
];

const RewardSteps = () => {
    const auth = getAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, [])

    return (
        <div className="relative py-12 px-4 md:py-10 md:px-8 lg:px-[100px] flex flex-col gap-10 md:gap-8 bg-primary-500 md:items-center">
            <Text
                content={texts?.EarnRewardsHeading}
                className="h4-semibold md:h3-semibold text-basicWhite w-[250px] md:w-auto md:text-center"
            />
            <div className="flex flex-col gap-8 md:gap-7 max-w-[464px]">
                {rewardSteps.map((item, index) => {
                    return (
                        <div className="flex gap-3 md:items-center" key={index}>
                            <Text
                                content={`0${index + 1}`}
                                className="h3-semibold bg-refer-and-earn-steps bg-clip-text text-transparent"
                            />
                            <Text
                                content={item}
                                className="p4-regular text-secondary-100"
                            />
                        </div>
                    );
                })}
            </div>
            <div className="flex flex-col gap-4">
                {!auth && !loading ? (
                    <ReferralInfo
                        buttonType="tertiary"
                        position="justify-start md:justify-center"
                    />
                ) : null}
                <Text
                    content={texts?.KindlyCompleteKyc}
                    className="p5-regular md:p4-regular text-gray-300 text-center md:text-left"
                />
            </div>
            <div className="absolute top-0 right-0 w-[102px] h-[94px] md:w-[110px] md:h-[147px] lg:w-auto lg:h-auto">
                <Image
                    src="/images/refer-and-earn/refer-earn-jiraaf-arrow.svg"
                    className="w-full h-full"
                    alt="jiraaf-arrow"
                />
            </div>
        </div>
    );
};

export default RewardSteps;
